<template lang="html">
  <div class="h-100 pa3">
    <div class="tc pl-title mb3">Data visualizations</div>
    <div class="mh3 pa3 flex-grow">
      <div class="flex justify-center mb2">
        <img src="/static/pieChartColour.svg" alt="chord-diagram" class="ma3" />
        <img src="/static/cloudColour.svg" alt="word-cloud" class="ma3" />
      </div>
      <p class="pl-subheading tc">
        Click on these icons to see data visualizations that show your students
        ideas and engagement from the RoundTable.
      </p>
    </div>
    <div class="flex justify-center">
      <pl-button @click.native="$emit('close')" class="pl-primary">
        Got it!
      </pl-button>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {};
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
</style>



// WEBPACK FOOTER //
// onlineWalkthroughShareableGraphics.vue?5379b3e8